import { render, staticRenderFns } from "./generate-ap.vue?vue&type=template&id=357a8836"
import script from "./generate-ap.vue?vue&type=script&lang=js"
export * from "./generate-ap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports